<template>
  <div class="screen-whole">
    <h1 class="title has-text-centered">保存中（処方一覧）</h1>
    <div class="align-right">
      <b-button class="is-primary" @click="backToMenu"
        >戻る</b-button
      >
    </div>

    <div class="content-area">
      <p class="note">
        未完了一覧から処方を作成する場合は、仮受付番号を選択してください。
      </p>
      <p class="counting align-right">
        全 {{ cpapRequestDraftList.length }} 件
      </p>

      <b-table
        :data="cpapRequestDraftList"
        :columns="columns"
        class="cpap-temp-prescription-list"
      >
        <template slot-scope="props">
          <b-table-column field="tempReceptionNo" label="仮受付番号" sortable>
            <a @click="confirmPrescriptionRestart(props.row.tempReceptionNo)">
              {{ props.row.tempReceptionNo }}
            </a>
          </b-table-column>
          <b-table-column field="patientCardId" label="診察券ID" sortable>
            {{ props.row.patientCardId }}
          </b-table-column>
          <b-table-column field="patientName" label="患者名" sortable>
            {{ props.row.patientLastName }} {{ props.row.patientFirstName }}
          </b-table-column>
          <b-table-column field="applicationType" label="処方種別" sortable>
            {{ applicationTypeConverter(props.row.applicationType, props.row.resume, props.row.cancelResume, props.row.depositUseFlag) }}
          </b-table-column>
          <b-table-column field="createdAt" label="保存日時" sortable>
            {{ props.row.updatedAt }}
          </b-table-column>
          <b-table-column field="createdUser" label="保存者" sortable>
            {{ props.row.userLastName }} {{ props.row.userFirstName }}
          </b-table-column>
          <b-table-column field="delete" label="削除"
            ><button
              class="delete-button"
              @click="confirmDelete(props.row.tempReceptionNo)"
            >
              <b-icon icon="delete-forever-outline" /></button
          ></b-table-column>
        </template>

        <template #empty>
          <div class="has-text-centered">保存されている処方データはありません</div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import {
  cpapKindMap,
} from "@/components/mock/base/const.js";

export default {
  data() {
    return {
      columns: [
        {
          field: "tempReceptionNo",
          label: "仮受付番号",
          sortable: true,
        },
        {
          field: "patientCardId",
          label: "診察券ID",
          sortable: true,
        },
        {
          field: "patientName",
          label: "患者名",
          sortable: true,
        },
        {
          field: "applicationType",
          label: "処方種別",
          sortable: true,
        },
        {
          field: "createdUser",
          label: "保存者",
          sortable: true,
        },
        {
          field: "createdAt",
          label: "保存日時",
          sortable: true,
        },
        {
          field: "delete",
          label: "削除",
          sortable: true,
          // width: 20,
        },
      ],

      cpapRequestDraftList: [],
      belongsId: "",
      cpapKindMap:cpapKindMap,
    };
  },

  methods: {
    // back button
    backToMenu() {
      this.$router.push({ path: "CpapMenu" });
    },
    // 処方種別
    applicationTypeConverter(applicationType, resume, cancelResume, depositUseFlag) {
      var applicationTypeName = "";
      if (applicationType == cpapKindMap.application && !depositUseFlag) {
        applicationTypeName = "新規処方申込み";
      } else if (applicationType == cpapKindMap.application && depositUseFlag) {
        applicationTypeName = "新規処方申込み（預託機）";
      } else if (applicationType == cpapKindMap.applicationResume && cancelResume && !depositUseFlag) {
        applicationTypeName = "処方再開申込み";
      } else if (applicationType == cpapKindMap.applicationResume && cancelResume && depositUseFlag) {
        applicationTypeName = "処方再開申込み（預託機）";
      } else if (applicationType == cpapKindMap.applicationResume && resume) {
        applicationTypeName = "処方再開申込み（転入）";
      }
      return applicationTypeName;
    },
    // for get list of draft.
    queryCpapRequestDraft() {
      const THIS = this;
      var body = { belongsId: this.belongsId };
      this.apiCall(
        (client) => {
          return client.apis.externalCpap.queryCpapRequestDraft({
            body: body,
          });
        },
        (result) => {
          THIS.cpapRequestDraftList = result.obj.cpapRequestDraftList;
        },
        (error) => {
          THIS.showErrorMessage(error);
        }
      );
    },
    // for select target data.
    confirmPrescriptionRestart(tempReceptionNo) {
      const THIS = this;
      this.$dialog.confirm({
        title: " ",
        message: `仮受付番号：${tempReceptionNo} の処方を作成します。`,
        cancelText: "キャンセル",
        confirmText: "OK",
        onConfirm: () => {
          THIS.selectCpapRequestDraft(tempReceptionNo);
        },
      });
    },
    selectCpapRequestDraft(tempReceptionNo) {
      const THIS = this;
      var body = {
        tempReceptionNo: tempReceptionNo,
        belongsId: this.belongsId,
      };
      this.apiCall(
        (client) => {
          return client.apis.externalCpap.selectCpapRequestDraft({
            body: body,
          });
        },
        (result) => {
          THIS.$router.push({
            name: "CpapRequest",
            params: { results: result.obj },
          });
        },
        (error) => {
          THIS.showErrorMessage(error);
        }
      );
    },
    // for deletion
    confirmDelete(tempReceptionNo) {
      const THIS = this;
      this.$dialog.confirm({
        title: " ",
        message: `仮受付番号：${tempReceptionNo} の処方を削除します。<br>一度削除すると元には戻せませんがよろしいですか？`,
        cancelText: "キャンセル",
        confirmText: "OK",
        onConfirm: () => {
          THIS.deleteCpapRequestDraft(tempReceptionNo);
        },
      });
    },
    deleteCpapRequestDraft(tempReceptionNo) {
      const THIS = this;
      var body = {
        tempReceptionNo: tempReceptionNo,
        belongsId: this.belongsId,
      };
      this.apiCall(
        (client) => {
          return client.apis.externalCpap.deleteCpapRequestDraft({
            body: body,
          });
        },
        (result) => {
          THIS.showSuccess(result, THIS.queryCpapRequestDraft);
        },
        (error) => {
          THIS.showErrorMessage(error);
        }
      );
    },
  },

  created() {
    this.belongsId = JSON.parse(sessionStorage.getItem("userInfo")).belongsId;
  },

  mounted() {
    this.queryCpapRequestDraft();
  },
};
</script>

<style scoped>
.screen-whole {
  width: 70%;
  margin: 1em auto;
}
.cpap-prescription-link {
  margin-bottom: 1em;
  font-size: 18px;
}
.cpap-prescription-link a {
  color: #2255ff;
  font-size: 18px;
  font-weight: bold;
}
.align-right {
  text-align: right;
}
.content-area {
  margin-top: 1em;
  margin-bottom: 1em;
}
.note {
  font-size: 18px;
}
.counting {
  margin-right: 1.5em;
  font-size: 18px;
}
.item-area {
  margin-top: 0.5em;
  padding: 1em;
  border: 1px solid;
  border-radius: 8px;
}
.cpap-temp-prescription-list {
  margin: 1em 0;
}

.cpap-temp-prescription-list a {
  color: #0d4794;
}

.cpap-temp-prescription-list a:hover {
  font-weight: bold;
}

.delete-button {
  background: #ffffff;
  border: 1px solid #d8d8d8;
  border-width: thin;
  border-radius: 4px;
}
</style>

<style>
.switch-button .switch input + .check:before {
  background: #ffffff;
}
.cpap-temp-prescription-list .table-wrapper {
  border: 1px solid #cac8c8 !important;
  border-radius: 4px !important;
  max-height: 800px;
  overflow-y: auto;
  position: relative;
}
.cpap-temp-prescription-list table {
  padding: 0.5em;
}
.cpap-temp-prescription-list table th {
  position: sticky;
  top: 0;
  background: #ffffff;
}
.cpap-temp-prescription-list table th .th-wrap {
  font-weight: bold;
}
.cpap-temp-prescription-list table th,
.cpap-temp-prescription-list table td {
  font-size: 14px !important;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapRequestDraftView.vue